module.exports = __webpack_public_path__ + "img/circle-letter.9cb8cac2.svg";